export const DEFAULT_FONT = {
  ROOT: "Open Sans",
  HEADINGS: "Open Sans"
};

export const LIST_FONTS = [
  "Alegreya",
  "Antic Slab",
  "Arial",
  "Century Gothic",
  "Arizonia",
  "Assistant",
  "Avenir",
  "Baskerville",
  "Bree Serif",
  "Brush Script MT",
  "Cabin",
  "Cinzel",
  "Cormorant Garamond",
  "Courier New",
  "Impact",
  "Crimson Text",
  "Domine",
  "Fira Sans",
  "Gabriela",
  "Garamond",
  "Georgia",
  "Glacial Indifference",
  "Helvetica",
  "Josefin Sans",
  "Josefin Slab",
  "Lato",
  "Montserrat",
  "Mr Dafoe",
  "Mukta",
  "Open Sans",
  "perpetua-titling-mt",
  "Playfair Display",
  "Poppins",
  "PringleandTweed",
  "Articulat Demibold",
  "articulatcf-demibold",
  "articulatcf-regular",
  "articulatcf-demiboldoblique",
  "articulatcf-heavy",
  "Quicksand",
  "Rajdhani",
  "Raleway",
  "Roboto",
  "Source Sans Pro",
  "Tahoma",
  "Times New Roman",
  "Trebuchet MS",
  "Ubuntu",
  "Verdana",
  "white_gardenregular",
  "white_garden_wideregular",
  "optimaregular",
  "silver_south_scriptregular",
  "bell_mtbold",
  "bellezaregular",
  "dancing_scriptbold",
  "Calibri",
  "Lucida",
  "gothambold",
  "gothamblack",
  "gothambook",
  "gothammedium"
];

export const LIST_FONTS_MAIL = [
  "Arial",
  "Courier New",
  "Garamond",
  "Georgia",
  "Helvetica",
  "Impact",
  "Times New Roman",
  "Tahoma",
  "Trebuchet MS",
  "Verdana"
];

export const LIST_FONT_SIZES = [
  "6px",
  "7px",
  "8px",
  "9px",
  "10px",
  "11px",
  "12px",
  "13px",
  "14px",
  "15px",
  "16px",
  "17px",
  "18px",
  "19px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "36px",
  "40px",
  "48px",
  "60px",
  "80px"
]



// WEBPACK FOOTER //
// ./src/constants/fonts.js